import { useTranslate } from 'hooks/useTranslate';
import { FC, useMemo } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import { usePublishTradingOfferModal } from '../context/PublishTradingOfferModalContext';

const PublishTradingOfferModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = usePublishTradingOfferModal();

  const isSellOffer = data.tradingOffer?.type === 'SELL';
  const isSuccessView = !!data.publishedOffer;

  const modalTitle = useMemo(() => {
    if (isSuccessView) return t('Success');
    if (data.modalActionType === actionTypes.EDIT) return t('EditOffer');
    return isSellOffer ? t('ConfirmSellOffer') : t('ConfirmBuyOffer');
  }, [data.modalActionType, isSellOffer, isSuccessView, t]);

  return (
    <Modal.Header className="border-bottom">
      <h5 className="modal-title mb-0">{modalTitle}</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default PublishTradingOfferModalHeader;
